import { graphql } from 'react-relay';
export const GetSpaceNameQuery = graphql`
	query GetSpaceNameQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			name
		}
	}
`;
